module.exports = __webpack_public_path__ + "img/kak.6d6f8638.png";